import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MiniResourceCard = makeShortcode("MiniResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "advanced-topics"
    }}>{`Advanced topics`}</h1>
    <p>{`There's a lot more to plugin development than what we've covered so far. For more advanced topics, please have a look at the `}<a parentName="p" {...{
        "href": ""
      }}>{`resources section`}</a>{`. Among other things, you'll find information about:`}</p>
    <MiniResourceCard slots="image,heading,text,link" repeat="5" theme="lightest" inRow="3" mdxType="MiniResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "200px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/fcc1fa39cfd68f77990070034b71991d/a5e6d/file.webp 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/fcc1fa39cfd68f77990070034b71991d/a6b4f/file.jpg 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/fcc1fa39cfd68f77990070034b71991d/a6b4f/file.jpg",
            "alt": "Folder icon",
            "title": "Folder icon",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "file-io"
    }}>{`File I/O`}</h4>
    <p>{`Save data to and load data from the file system`}</p>
    <p><a parentName="p" {...{
        "href": "../../resources/recipes/file-operation/"
      }}>{`File I/O`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "200px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/121dcdddef7a604105487dbe03c86dc9/a5e6d/network.webp 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/121dcdddef7a604105487dbe03c86dc9/a6b4f/network.jpg 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/121dcdddef7a604105487dbe03c86dc9/a6b4f/network.jpg",
            "alt": "Network icon",
            "title": "Network icon",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "network-io"
    }}>{`Network I/O`}</h4>
    <p>{`Make network requests to fetch data from the internet`}</p>
    <p><a parentName="p" {...{
        "href": "../../resources/recipes/network/"
      }}>{`Network I/O`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "200px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/47a99fabdc6f3b393ea476b299042378/a5e6d/ui.webp 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/47a99fabdc6f3b393ea476b299042378/a6b4f/ui.jpg 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/47a99fabdc6f3b393ea476b299042378/a6b4f/ui.jpg",
            "alt": "Application window icon",
            "title": "Application window icon",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "user-interface"
    }}>{`User Interface`}</h4>
    <p>{`Add a variety of UI elements to your plugin`}</p>
    <p><a parentName="p" {...{
        "href": "../../resources/fundamentals/create-ui/"
      }}>{`Adding User Interfaces`}</a></p>
    {/* 
     ![Complex hierarchical component structure icon](react.jpg)
     #### React
     Use React to build highly interactive user interfaces
     [//]: # (TODO: Add right links)
     [React in UXP](#)
     */}
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "200px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/3b0ca396e0bd571917c62a879d4a0e9d/a5e6d/more.webp 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/3b0ca396e0bd571917c62a879d4a0e9d/a6b4f/more.jpg 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/3b0ca396e0bd571917c62a879d4a0e9d/a6b4f/more.jpg",
            "alt": "Ellipsis",
            "title": "Ellipsis",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "and-much-more"
    }}>{`And much more`}</h4>
    <p>{`See all the resources available to you for plugin development`}</p>
    <p><a parentName="p" {...{
        "href": "../../resources/"
      }}>{`All resources`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      